import React, { useState, useLayoutEffect } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import { OFFERS_AND_PROMOTIONS_CONSTANTS } from '../Constants/OffersAndPromotionsConstants';
import SampleArrowNext from './SampleArrowNext';
import SampleArrowPrev from './SampleArrowPrev';
import { ReactSVG } from 'react-svg';
import { formatDateTime, getUnixTimeInSeconds } from 'common/utilities/dayJsUtils';
import { modifyOffers, isTimeValid, sanitizeContent } from '../../CouponsLanding/utils/CouponUtils';
import TimerComponent from 'organisms/CouponsLanding/Presentation/TimerComponent';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { DealsDetailModal } from '../../DealsAndOffersLanding/Presentation/DealsDetailModal';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { TENANT_IMAGE_BASE_URL } from '@kfc-global/react-shared/config/config.constants';
import { ViewOfferDetails } from '../../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { getFullImagePath } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const OffersAndPromotionsItem = props => {
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [modalData, setModalData] = useState({});
  const [rangeValue, updateRangeValue] = useState(0);
  const [isDealModalOpen, openDealModal] = useState(false);
  const [visibleCards, setVisibleCards] = useState(0);
  const carousal = React.useRef(null);
  const { TimerRibbonRedOutlined, RedFilledRibbon, TimerIcon, StripsIcon, ViewDetailsArrow } = IMAGE_PATH;
  const { contentData = [], onOffersViewAll = null, onRedeem = null, tenantId = '', tenantData = {} } = props;

  const {
    CAROUSAL_CONFIG = {},
    BUTTON_TEXT = {},
    OFFERS_HEADER_TEXT = {},
    CONTENT_DATA_MAX_LENGTH_TO_SCROLL = null,
    VALIDITY_TEXT = '',
    CONTENT_DATA_MAX_LENGTH_TO_SHOW = null,
    DEFAULT_IMAGE_PATH,
    OFFER_APPLIED,
  } = OFFERS_AND_PROMOTIONS_CONSTANTS;
  const { SPEED = null, SLIDES_TO_SHOW = null, SLIDES_TO_SCROLL = null } = CAROUSAL_CONFIG;
  const { VIEW_DETAILS = '', REDEEM = '' } = BUTTON_TEXT;
  const { OFFERS_AND_DEALS = '', VIEW_ALL_DEALS = '' } = OFFERS_HEADER_TEXT;
  /* OnClicking Next Arrow Button */
  const onNextCard = () => {
    if (currentSlide < contentData.length - 1) {
      let updatedCurrentSlide;
      if (currentSlide + SLIDES_TO_SCROLL > contentData.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = contentData.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
  };

  /* In dragging scroll bar */
  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
  };

  /**
   * Open Deals Modal
   */
  const openDealsModalFunc = item => {
    const filteredData = modifyOffers(item);
    setModalData(filteredData);
    openDealModal(true);
    ViewOfferDetails({ offerTitle: item.titleValue });
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    //afterChange: ( current, prev ) => updateCurrentSlide( current ),
    variableWidth: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 1950,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1720,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  /* Rendering Image Text  card */
  const imageTextCard = (couponCode, smallText, titleValue, imageSrc, item) => {
    return (
      <React.Fragment>
        <ImageComponent
          srcFile={getFullImagePath(imageSrc, tenantData, false, false, true)}
          alt={'No-Image'}
          defaultPath={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${DEFAULT_IMAGE_PATH}`}
          className='offersImageText-background'
        />
        <div className='offersCard-content'>
          <div className='offersImageTextCard-title'>{sanitizeContent(titleValue)}</div>
          <div className='offersCard-text'>{sanitizeContent(smallText)}</div>
          <div className='offersButton-item'>
            <ButtonComp
              data-testid='view-details-btn-img-txt'
              onClick={() => openDealsModalFunc(item)}
              className='offersView-details'
              aria-label={`${translateWithI18Next(VIEW_DETAILS)} ${titleValue}`}
            >
              {translateWithI18Next(VIEW_DETAILS)}
            </ButtonComp>
            <ButtonComp
              className='offers-redeem button transparent-btn black-border whiteButton blackBorder'
              onClick={() => onRedeem(couponCode)}
              disabled={item?.isApplied}
              data-testid='offer-and-promtion-image-text-button'
              aria-label={`${translateWithI18Next(REDEEM)} ${titleValue}`}
            >
              {item?.isApplied ? translateWithI18Next(OFFER_APPLIED) : translateWithI18Next(REDEEM)}
            </ButtonComp>
          </div>
        </div>
      </React.Fragment>
    );
  };

  /* Rendering Image Only card */
  const imageCard = (couponCode, imageSrc, item) => {
    return (
      <React.Fragment>
        <ImageComponent
          srcFile={getFullImagePath(imageSrc, tenantData, false, false, true)}
          className='offersOnlyImage-background'
          alt={'No-Image'}
          defaultPath={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${DEFAULT_IMAGE_PATH}`}
        />
        <div className='offersCard-content offersFullImageCard-content'>
          <div className='offersButton-item fullImageCardButton-item'>
            <ButtonComp
              data-testid='view-details-btn-img'
              onClick={() => openDealsModalFunc(item)}
              className='offersView-details'
              aria-label={`imageCard_${translateWithI18Next(VIEW_DETAILS)}`}
            >
              {translateWithI18Next(VIEW_DETAILS)}
            </ButtonComp>
            <ButtonComp
              className='offers-redeem button transparent-btn black-border whiteButton blackBorder'
              onClick={() => onRedeem(couponCode)}
              disabled={item?.isApplied}
              data-testid='offer-and-promtion-image-button'
              aria-label={`imageCard_${translateWithI18Next(REDEEM)}`}
            >
              {item?.isApplied ? translateWithI18Next(OFFER_APPLIED) : translateWithI18Next(REDEEM)}
            </ButtonComp>
          </div>
        </div>
      </React.Fragment>
    );
  };

  /* Rendering Text Only card */
  const textCard = (couponCode, smallText, titleValue, validityEndTime, item) => {
    return (
      <React.Fragment>
        <section className='offersCard-content'>
          <section className='offersOnlyTextCard-title'>{titleValue}</section>
          <section className='offersOnlyTextCard-text'>{smallText}</section>
          <section className='validity'>
            {VALIDITY_TEXT} <span>{formatDateTime(getUnixTimeInSeconds(validityEndTime), 'DD/MM/YY')}</span>
          </section>
          <section className='offersButton-item'>
            <ButtonComp
              data-testid='view-details-btn-txt'
              onClick={() => openDealsModalFunc(item)}
              className='offersView-details'
              aria-label={`${translateWithI18Next(VIEW_DETAILS)}_textCard`}
            >
              {translateWithI18Next(VIEW_DETAILS)}
            </ButtonComp>
            <ButtonComp
              className='offers-redeem button transparent-btn black-border whiteButton blackBorder'
              onClick={() => onRedeem(couponCode)}
              disabled={item?.isApplied}
              data-testid='offer-and-promtion-text-button'
              aria-label={`${translateWithI18Next(REDEEM)}_textCard`}
            >
              {item?.isApplied ? translateWithI18Next(OFFER_APPLIED) : translateWithI18Next(REDEEM)}
            </ButtonComp>
          </section>
        </section>
      </React.Fragment>
    );
  };

  /* show ribbon component  */
  const getRibbon = data => {
    if (data?.showTimer && isTimeValid(data?.validityEndTime)) {
      const header = (
        <span className='coupon-time-block'>
          <img className='offers-timer' src={TimerIcon} alt='Offers Timer' />
          <TimerComponent endTime={data?.validityEndTime} />
        </span>
      );
      return (
        <div className='offersRibbon-container'>
          <ReactSVG src={TimerRibbonRedOutlined} className='offers-ribbon' />
          <span className='offersTimer-text'>{header}</span>
        </div>
      );
    } else if (data?.header) {
      const header = data?.header;
      return (
        <div className='offersRibbon-container'>
          <ReactSVG src={RedFilledRibbon} className='offers-ribbon' />
          <span className='ribbon-text'>{header}</span>
        </div>
      );
    }
  };

  /* draw drawOffersCarousal component  */
  const drawOffersCarousal = () => {
    return contentData.map((item, index) => {
      const { cardType, couponCode, smallText, titleValue, imageSrc, validityEndTime } = item || {};
      return (
        index < CONTENT_DATA_MAX_LENGTH_TO_SHOW && (
          <div key={index}>
            <div
              className={`offers-card ${
                index === currentSlide + visibleCards - 1 && 'offersCard-fade lastOffersCard-fade'
              }`}
            >
              {getRibbon(item)}
              {cardType === 'image-text' && imageTextCard(couponCode, smallText, titleValue, imageSrc, item)}
              {cardType === 'image' && imageCard(couponCode, imageSrc, item)}
              {cardType === 'text' && textCard(couponCode, smallText, titleValue, validityEndTime, item)}
            </div>
          </div>
        )
      );
    });
  };

  useLayoutEffect(() => {
    const calculateMarginWidth = () => {
      return window.innerWidth > 1023 ? [310.0 + 37, window.innerWidth * 0.1] : [250.0 + 37, 20.0];
    };

    const calculateVisibleItems = () => {
      const [cardWidth, leftMargin] = calculateMarginWidth();
      const contentWidth = window.innerWidth - leftMargin;
      let visibleItems = Math.ceil(contentWidth / cardWidth);

      if (visibleItems === 1) {
        visibleItems += 1;
      }
      return visibleItems;
    };

    const handleResize = () => setVisibleCards(calculateVisibleItems());

    window.addEventListener('resize', handleResize);
    handleResize();
  }, []);

  return (
    <div className='offersCard-container' data-testid='offersCard-container-test'>
      <div className='offers-Icon'>
        <ReactSVG src={StripsIcon} />
      </div>

      <div className='offersContainerHeader-items'>
        <h2 className='offersContainer-header'>{translateWithI18Next(OFFERS_AND_DEALS)}</h2>
        <div className='view-all-text'>
          <button
            className='offersViewAll-link viewAll-link'
            onClick={onOffersViewAll}
            data-testid='view-all-deals-handler'
            tabIndex='0'
          >
            {translateWithI18Next(VIEW_ALL_DEALS)}
          </button>
          <ReactSVG className='offersViewAlldeals-arrow' src={ViewDetailsArrow} />
        </div>
      </div>
      <div className='offersCard-list'>
        <div className='offersCarousal-list'>
          <CarauselComp settings={settings} carousalRef={carousal}>
            {drawOffersCarousal()}
          </CarauselComp>
        </div>
        {contentData.length > CONTENT_DATA_MAX_LENGTH_TO_SCROLL && (
          <div className='offers-slideContainer'>
            <input
              className='offers-slider'
              type='range'
              min='0'
              max={contentData.length - SLIDES_TO_SHOW}
              value={rangeValue}
              id='myRange'
              onChange={onUpdateRange}
              tabIndex='-1'
              aria-hidden='true'
            />
          </div>
        )}
      </div>
      {isDealModalOpen && (
        <DealsDetailModal
          data-testid='deals-modal'
          data={modalData}
          couponApplyHandler={onRedeem}
          isDealModalOpen={isDealModalOpen}
          handleClose={() => openDealModal(false)}
        />
      )}
    </div>
  );
};
export default OffersAndPromotionsItem;
